export default __webpack_public_path__ + "static/media/logo-slack.cd48b339.svg";